import { getAvisoInfo } from "../services";
import { generateAndDownloadPDF } from "./pdfHelper";

/**
 * Generates PDF for an Aviso de Cobro
 * This function is kept for backward compatibility with existing code
 * @param {string|number} id - The aviso ID
 * @param {object} avisoData - Optional aviso data (if already fetched, avoids extra query)
 * @returns {Promise<{success: boolean, error?: Error}>}
 */
export const handleGenerarPDF = async (id, avisoData = null) => {
  try {
    console.log('[pdfUtils] handleGenerarPDF called with id:', id);
    console.log('[pdfUtils] avisoData provided:', avisoData ? 'Yes' : 'No');

    // Use provided data or fetch from API
    const data = avisoData || await getAvisoInfo(id);

    console.log('[pdfUtils] Data received:', data);
    console.log('[pdfUtils] Data type:', typeof data);
    console.log('[pdfUtils] Is array?:', Array.isArray(data));

    if (!data || typeof data !== 'object') {
      console.error('[pdfUtils] Invalid avisoData received:', data);
      return { success: false, error: 'Invalid data structure' };
    }

    console.log('[pdfUtils] Calling generateAndDownloadPDF...');
    const result = await generateAndDownloadPDF(data);
    console.log('[pdfUtils] PDF generation result:', result);
    return result;
  } catch (error) {
    console.error("[pdfUtils] Error al generar PDF:", error);
    console.error("[pdfUtils] Error stack:", error.stack);
    return { success: false, error };
  }
};
